import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const wrapperCss = "w119v8ai";
export const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const containerCss = "ciyukyt";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const avatarContainerCss = "a1j0dvls";
export const AvatarContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(avatarContainerCss, props.className)} />;
});
const avatarDropdownContainerCss = "a173i8yx";
export const AvatarDropdownContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(avatarDropdownContainerCss, props.className)} />;
});
const avatarIconCss = "a1a20ih9";
export const AvatarIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const alt = '';
  return <Component ref={ref} {...restProps} alt={alt} className={classNames(avatarIconCss, props.className)} />;
});
const headingIsGuestCss = "h8bynzm";
const headingIsContactCss = "h71xd2q";
const headingCss = "hrgg8jp";
export const Heading = forwardRef((props, ref) => {
  const {
    isGuest,
    isContact,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headingCss, {
    [headingIsGuestCss]: isGuest,
    [headingIsContactCss]: isContact
  }, props.className)} />;
});
const nameStrikeCss = "nheemrd";
const nameCss = "nhckh0";
export const Name = forwardRef((props, ref) => {
  const {
    strike,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(nameCss, {
    [nameStrikeCss]: strike
  }, props.className)} />;
});
const nameStringStrikeCss = "n1353dos";
const nameStringCss = "n17dqe3n";
export const NameString = forwardRef((props, ref) => {
  const {
    strike,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(nameStringCss, {
    [nameStringStrikeCss]: strike
  }, props.className)} />;
});
const rowCss = "r1y42bwh";
export const Row = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rowCss, props.className)} />;
});
const infoContainerCss = "i1plgewr";
export const InfoContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(infoContainerCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");